// BRK-S046 — the consistent required-vs-optional label marker shared by
// TextField / SelectField / PhoneField (DRY). A required field shows a danger-
// colored "*"; an optional field shows a muted "(optional)". Both markers are
// aria-hidden AND rendered as a SIBLING of the <label> (never inside it), so
// they stay out of the field's accessible/label name — screen readers get
// "required" from the input's `required`/`aria-required` instead, and
// getByLabelText("Legal name") stays exact in tests.
export function FieldMarker({
  required,
  optional,
}: {
  required?: boolean;
  optional?: boolean;
}) {
  if (required) {
    return (
      <span aria-hidden="true" className="text-xs text-brk-danger">
        *
      </span>
    );
  }
  if (optional) {
    return (
      <span aria-hidden="true" className="text-xs font-normal text-brk-dim">
        (optional)
      </span>
    );
  }
  return null;
}
